(() => {
  if (window.LoxLeadTracking) return;
  const node = document.querySelector('[data-lox-lead-settings]');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const pendingKey = 'lox.inquiry.pending.v1';
  const sentKey = 'lox.inquiry.sent.v1';
  const pageKinds = { '/pages/custom-corporate-gifts': 'corporate_gifts', '/pages/mit-power-bank': 'mit_power_bank', '/pages/handmade-soap-gift-box': 'handmade_soap' };
  const formNames = { corporate_gifts: 'LOX corporate gift inquiry', mit_power_bank: 'LOX MIT power bank inquiry', handmade_soap: 'LOX handmade soap gift inquiry' };
  const pageType = () => pageKinds[location.pathname.replace(/^\/en(?=\/|$)/, '').replace(/\/$/, '')] || 'storefront';
  const privacy = purpose => {
    const api = window.Shopify?.customerPrivacy;
    if (!api) return true;
    const check = purpose === 'analytics' ? 'analyticsProcessingAllowed' : 'marketingAllowed';
    return typeof api[check] !== 'function' || api[check]();
  };
  const preview = () => Boolean(window.Shopify?.designMode || window.Shopify?.theme?.role === 'unpublished' || new URL(location.href).searchParams.has('preview_theme_id'));
  const get = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; } };
  const set = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  const id = () => window.crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
  const gaValid = /^G-[A-Z0-9]+$/.test(config.ga4_id || '');
  const adsValid = value => /^AW-\d+\/[A-Za-z0-9_-]+$/.test(value || '');
  const queued = [];
  let timer;
  const gtag = (name, parameters) => {
    if (typeof window.gtag === 'function') window.gtag('event', name, parameters);
    else {
      queued.push([name, parameters]);
      if (!timer) {
        let tries = 0;
        timer = setInterval(() => {
          if (typeof window.gtag === 'function') {
            clearInterval(timer); timer = null;
            while (queued.length) {
              const [event, params] = queued.shift();
              if (privacy(event === 'conversion' ? 'marketing' : 'analytics')) window.gtag('event', event, params);
            }
          } else if (++tries > 150) {
            clearInterval(timer); timer = null; queued.length = 0;
          }
        }, 100);
      }
    }
  };
  const event = (name, params, destination) => {
    if (!config.enabled) return;
    const isPreview = preview();
    if (isPreview && !config.preview_debug) return;
    if (gaValid && privacy('analytics')) {
      gtag(name, { ...params, send_to: config.ga4_id, ...(isPreview ? { debug_mode: true } : {}) });
    }
    if (!isPreview && adsValid(destination) && privacy('marketing')) {
      gtag('conversion', { send_to: destination, transaction_id: params.lead_id || id() });
    }
  };
  const startInquiry = form => {
    if (window.Shopify?.designMode || !form.checkValidity()) return;
    const token = id();
    const reference = form.querySelector('[data-lox-inquiry-reference]');
    if (reference) reference.value = token;
    set(pendingKey, { id: token, form: form.dataset.loxInquiryForm, pathname: location.pathname, time: Date.now() });
  };
  const success = () => {
    if (document.querySelector('[data-lox-inquiry-errors]')) {
      if (get(pendingKey)?.pathname === location.pathname) remove(pendingKey);
      return;
    }
    const marker = document.querySelector('[data-lox-inquiry-success]');
    if (!marker) return;
    const pending = get(pendingKey);
    if (!pending || typeof pending.id !== 'string' || !/^[A-Za-z0-9-]{8,100}$/.test(pending.id) || pending.form !== marker.closest('[data-lox-inquiry-form]')?.dataset.loxInquiryForm || pending.pathname !== location.pathname || !Number.isFinite(pending.time) || Date.now() - pending.time > 7200000 || Date.now() < pending.time) return;
    if (get(sentKey)?.id === pending.id) return;
    const canAnalytics = config.enabled && gaValid && privacy('analytics') && (!preview() || config.preview_debug);
    const canAds = config.enabled && !preview() && adsValid(config.ads_form_destination) && privacy('marketing');
    if (!canAnalytics && !canAds) return;
    set(sentKey, { id: pending.id });
    remove(pendingKey);
    event('generate_lead', { lead_id: pending.id, form_id: pending.form, form_name: formNames[pending.form] || 'LOX gift inquiry', contact_method: 'form', page_type: pending.form }, config.ads_form_destination);
    marker.focus({ preventScroll: true });
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.matches('[data-lox-inquiry-form]')) startInquiry(form);
  }, true);
  document.addEventListener('click', click => {
    if (click.button !== 0 || click.defaultPrevented || window.Shopify?.designMode) return;
    const link = click.target instanceof Element ? click.target.closest('a[href]') : null;
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.origin); } catch { return; }
    const host = url.hostname.toLowerCase();
    if (!['lin.ee', 'line.me', 'www.line.me'].includes(host) && url.protocol !== 'line:') return;
    const position = link.dataset.loxLinePosition || (link.closest('.lox-line') ? 'floating' : link.closest('.lox-corp') ? 'corporate_page' : 'other');
    event('line_click', { contact_method: 'line', link_domain: host || 'line', link_position: position, page_type: pageType() }, config.ads_line_destination);
  });
  document.addEventListener('visitorConsentCollected', success);
  window.addEventListener('pageshow', success);
  window.LoxLeadTracking = { version: '1.1.0' };
  success();
})();
